'use client'

import { useEffect } from 'react'
import { Button } from '@/components/ui/Button'

// ============================================================================
// GLOBAL ERROR BOUNDARY — catches runtime errors within routes.
// ============================================================================

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}): React.JSX.Element {
  useEffect(() => {
    // Surface the error for debugging/observability.
    console.error('NovaVerse route error:', error)
  }, [error])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-6 text-center text-foreground">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-nova-500/10 text-nova-500">
        <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
        </svg>
      </div>
      <div className="space-y-2">
        <h1 className="text-2xl font-bold tracking-tight">Something went wrong</h1>
        <p className="max-w-md text-sm text-muted">
          An unexpected error occurred while loading this page. You can try again.
        </p>
      </div>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Button onClick={() => reset()} size="md">
          Try again
        </Button>
        <Button href="/" variant="secondary" size="md">
          Back to Home
        </Button>
      </div>
    </div>
  )
}
